export default __webpack_public_path__ + "static/media/create-order.4cbed138.png";